export default "__VITE_ASSET__Rj2qhlFi__"